import { EditPermissions } from '../../../../../../../shared/models';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { getEditTypes } from '../../../delegatorUtils';
import { required } from '../../../../../../../shared/utils';

export interface NestedEndNodeData {
  name: string;
  description: string;
}

export interface LogicData {
  key: string;
  value: string;
}

export interface NestedEndNodeForms {
  NestedEndNodeForm: FormGroup;
  LogicForm: FormGroup;
}

export class nestedEndNode {

  integration: any = {};

  constructor() {
    this.integration = {
      'integrationType': 'endNode',
      'endNode': {
        'endNodeType': 'nested'
      }
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): NestedEndNodeForms {
    const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);
    const logicData = this.getLogicData(stepData);

    return {
      NestedEndNodeForm: this.buildForm(formData, editFlows),
      LogicForm: this.buildLogicForm(logicData, editFlows)
    };
  }

  private static getFromData(stepData: { [index: string]: any }): NestedEndNodeData {
    const integration = stepData?.integration ? stepData?.integration : {};

    return {
      name: integration.name ? integration.name : '',
      description: integration.description ? integration.description : ''
    };
  }

  private static getLogicData(stepData: { [index: string]: any }): LogicData[] {
    const integration = stepData?.integration ? stepData?.integration : {};
    const endNode = integration?.endNode ? integration?.endNode : {};
    const outputVars = endNode?.outputVars ? endNode?.outputVars : {
      '': ''
    };

    const logicData: LogicData[] = [];

    for (const key in outputVars) {
      if (outputVars.hasOwnProperty(key)) {
        const outputVar: LogicData = {
          key: key,
          value: outputVars[key]
        };
        logicData.push(outputVar);
      }
    }

    return logicData;
  }

  private static buildForm(formData: NestedEndNodeData, editFlows: boolean): FormGroup {
    return new FormGroup({
      name: new FormControl({
        value: formData.name,
        disabled: !editFlows
      }, required('Name')),
      description: new FormControl({
        value: formData.description,
        disabled: !editFlows
      }, required('Description'))
    });
  }

  private static buildLogicForm(logicData: LogicData[], editFlows: boolean): FormGroup {
    const outputVarArray = [];

    logicData.forEach(item => {
      outputVarArray.push(this.buildOutputVarGroup(item.key, item.value, editFlows));
    });

    return new FormGroup({
      outputVars: new FormArray(outputVarArray)
    });
  }

  public static buildOutputVarGroup(key: string, value: string, editFlows: boolean): FormGroup {
    return new FormGroup({
      key: new FormControl({
        value: key,
        disabled: !editFlows
      }, required('Key')),
      value: new FormControl({
        value: value,
        disabled: !editFlows
      }, required('Value'))
    });
  }

  get nodeData(): {} {
    return {
      integration: this.integration,
      'type': 'integration',
      metadata: {
        nodeVersion: '1.0.0'
      }
    };
  }
}
